import React, { useEffect, useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import Proptypes from 'prop-types';
import { COOKIES } from '../../_shared/constants/cookies';
import { getCookie } from '../../_shared/utils/cookies';
import loadFiveNineScripts from '../../_shared/helpers/loadFiveNineScripts';

import './Styles';

const propTypes = {
  initScriptsLoaded: Proptypes.bool
};

const defaultProps = {
  initScriptsLoaded: false
};

const ChatFiveNine = ({ initScriptsLoaded }) => {
  const [scriptsLoaded, setScriptsLoaded] = useState(initScriptsLoaded);
  const user = useSelector(state => state?.auth?.user, shallowEqual);
  const isChatEnabled = getCookie(COOKIES.IS_CHAT_ENABLED) === 'true';
  const superUser = JSON.parse(getCookie(COOKIES.SUPER_USER));
  const showChat = useSelector(
    state => state?.ui?.layout?.showChat,
    shallowEqual
  );
  const environment = process.env.REACT_APP_CUSTOM_NODE_ENV;

  const isAdmin = user?.superUserId && user?.superUserId !== user?.id;
  const proxyDealer = isAdmin && superUser ? user?.companyName : '';
  const proxyEmail = isAdmin && superUser ? superUser.email : '';
  const proxyName = isAdmin && superUser ? superUser.fullName : '';
  const url = window.location.href;
  const lang = navigator.languages
    ? navigator.languages[0]
    : navigator.language;

  const profile = lang.split('-')[0].includes('fr')
    ? 'TRCA-WebChat-FR'
    : 'TRCA-WebChat-EN';

  const customFields = {
    'Chat.isAdmin': {
      value: isAdmin,
      show: false,
      label: 'Is Admin',
      required: false
    },
    isAdmin: {
      value: isAdmin,
      show: false,
      label: 'Is Admin',
      required: false
    },
    'Chat.proxyUser': {
      value: proxyDealer,
      show: false,
      label: 'Proxy User',
      required: false
    },
    proxyUser: {
      value: proxyDealer,
      show: false,
      label: 'Proxy User',
      required: false
    },
    'Chat.proxyEmail': {
      value: proxyEmail,
      show: false,
      label: 'Proxy Email',
      required: false
    },
    proxyEmail: {
      value: proxyEmail,
      show: false,
      label: 'Proxy Email',
      required: false
    },
    'Chat.proxyName': {
      value: proxyName,
      show: false,
      label: 'Proxy Name',
      required: false
    },
    proxyName: {
      value: proxyName,
      show: false,
      label: 'Proxy Name',
      required: false
    },
    'Chat.url': {
      value: url,
      show: false,
      label: 'App URL',
      required: false
    },
    url: {
      value: url,
      show: false,
      label: 'App URL',
      required: false
    }
  };

  useEffect(() => {
    loadFiveNineScripts(() => {
      setScriptsLoaded(true);
    });
  });
  const shouldDisplayChat = () => {
    return user && (showChat || isChatEnabled) && scriptsLoaded;
  };

  return (
    <>
      {shouldDisplayChat() && (
        <div lang={lang?.split('-')?.[0]}>
          <five9-chat
            title-chat="TRADEREV"
            tenant={process.env.REACT_APP_FIVE_NINE_CHAT_TENANT}
            use-business-hours="true"
            toggle-sound-message="true"
            hide-chat-btn="false"
            profiles={profile}
            show-fields="true"
            show-profiles="false"
            show-dealer="true"
            show-country="false"
            custom-fields={JSON.stringify(customFields)}
            username={user?.fullName}
            email={user?.email}
            country-code="CA"
            dealership={user?.companyName}
            organization-id={user?.companyId}
            theme-src={process.env.REACT_APP_FIVE_NINE_CHAT_THEME_SRC}
            logo-src={process.env.REACT_APP_FIVE_NINE_CHAT_LOGO_SRC}
            name-space={`${user?.fullName} - TradeRev - ${environment}`}
          />
        </div>
      )}
    </>
  );
};

ChatFiveNine.propTypes = propTypes;
ChatFiveNine.defaultProps = defaultProps;

export default ChatFiveNine;
